function init() {
    const loginButton = document.querySelectorAll('.is-style-login > a.wp-block-button__link');
  
    if(loginButton.length > 0){
        loginButton.forEach(button => {
            button.setAttribute('data-target', 'login-modal');
            button.classList.add('login-modal-toggle');
        })
    }


}

export { init as default };
